import {Button} from 'antd'
import {course_getStudents_Api} from 'apis'
import {LayoutContext} from 'components/layouts/Default/LayoutContext'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useCallback, useContext, useMemo} from 'react'
import {useLocation} from 'react-use'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {StudentActionTypes} from 'views/AppLocals/Course'
import createContextMenu from 'views/AppLocals/factory/createContextMenu'
import {bindQueryParams} from 'views/AppLocals/functions/routerHelper'
import usePaginationHelper, {createPagerKey,} from 'views/AppLocals/hooks/usePaginationHelper'
import {NullAsDefault} from 'views/Shared'
import {renderStudent} from '../functions/renderStudent'
import {BiSolidEdit, BiTrash} from "react-icons/bi";
import {RiSearchEyeLine} from "react-icons/ri";
import {StudentFilter} from "../components/filters/StudentFilter";
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {useStudentForm} from "../../../AppLocals/Course/CourseClass/useStudentForm";
import classNames from "classnames";
import {EntityPaginationMeta} from "../../../AppLocals/EntityList";
import {SectionTemplate} from "../../Workspace";

const renderGridMeta = (props) =>
    (
        <LayoutContext.Consumer>
            {({isLg}) => (
                <div className={classNames(isLg ? 'col-span-2' : 'col-span-1')}>
                    <EntityPaginationMeta
                        {...props}
                        style={{position: 'inherit'}}
                    />
                </div>
            )}
        </LayoutContext.Consumer>
    )

const Students = ({
                      owner_id,
                      owner_type,
                      filter_actions = {
                          sortBy: 'sort-by',
                          keyword: 'keyword',
                          course_id: 'course',
                          course_class_id: 'course-class',
                          sub_class_name: 'sub-class-name',
                      },
                  }) => {
    const t = useTranslate()

    const location = useLocation()

    const {isSm} = useContext(LayoutContext)

    const sortBy = useRouteSearchParam(filter_actions.sortBy)
    const course_id = useRouteSearchParam(filter_actions.course_id)
    const course_class_id = useRouteSearchParam(filter_actions.course_class_id)
    const sub_class_name = useRouteSearchParam(filter_actions.sub_class_name)

    const {
        refreshKey,
        modal,
        handleAction,
        onCancel,
    } = useStudentForm({owner_id, owner_type})


    const renderContextMenu = useCallback(
        (item) =>
            createContextMenu(
                [
                    {
                        icon: <RiSearchEyeLine size={14} className="text-green-600"/>,
                        label: 'view detail',
                        key: StudentActionTypes.STUDENT_DETAIL,
                    },
                    {
                        icon: <BiSolidEdit size={14} className="text-blue-500"/>,
                        label: 'edit',
                        key: StudentActionTypes.STUDENT_UPDATE,
                    },
                    {
                        icon: <BiTrash size={14} className="text-primary-300"/>,
                        label: 'delete',
                        key: StudentActionTypes.STUDENT_DELETE,
                    },
                ].filter((e) => item),
                (key) => {
                    handleAction(key, item)
                }
            ),
        []
    )

    const refresh_deps = useMemo(
        () => [
            owner_id,
            owner_type,
            refreshKey,
            course_id, course_class_id,
            `refreshToken=${_.get(location.state, 'refreshToken')}`,
        ],
        [owner_id, owner_type, refreshKey, location.state]
    )

    const [pager_widget] = usePaginationHelper({
        filter_params: {
            owner_id,
            owner_type,
        },
        onInit: ({onSortChange = NullAsDefault, onFilterChange = NullAsDefault}) => {
            onFilterChange({
                course_id, course_class_id, sub_class_name,
            })
            onSortChange(sortBy)
        },
        pagerInfo: {
            RenderEntity: React.Fragment,
            PaginationMeta: renderGridMeta,
            renderItem: renderStudent({
                renderContextMenu,
                handleAction
            }),
            apiInfo: course_getStudents_Api,
            query: bindQueryParams([{id: owner_id}, {type: owner_type}]),

            renderWrap: (child, __, count) => !!count
                ? (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        {child}
                    </div>
                )
                : (
                    <div className="flex flex-col gap-6">
                        {child}
                    </div>
                ),
        },
        SortByWidget: NullAsDefault,
        renderSortBy: NullAsDefault,
        dependencies: [owner_id, owner_type, course_id, course_class_id, sub_class_name],
        query_params: filter_actions,
        withKey: createPagerKey(refresh_deps),
        AdvancedFilter: StudentFilter,
        isToggleDefault: true,
    })
    return (
        <div className="flex flex-1 flex-col space-y-3">
            <SectionTemplate
                title={t("student management")}
                description={t("manage the list of all students across the entire workspace including personal information learning history and status")}
                actionText={t("import add new student")}
                renderActionButton={() => (
                    <Button
                        type="primary"
                        className="mt-6 px-6 py-2 bg-indigo-500 text-white rounded-lg shadow-md hover:bg-indigo-600 transition"
                        onClick={() => {
                            handleAction(StudentActionTypes.STUDENT_CREATE)
                        }}>
                        {t('add new student')}
                    </Button>
                )}
            />
            {pager_widget}
            {modal}
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(Students)
